import React from "react";

const Header = () => (
  <header className="header">
    <img
      src="https://randomuser.me/api/portraits/men/32.jpg"
      alt="Rajo Mampionona Rakotoniaina"
      className="profile-pic"
    />
    <h1>Rajo Mampionona Rakotoniaina</h1>
    <h2>
      Développeur Fullstack (PHP, JavaScript, Python) | Expert Odoo v16 | Expet
      Zoho | Création & Intégration de Solutions Web sur mesure
    </h2>
    {/* <div className="social-links">
      <a href="mailto:rajo.boons1@gmail.com">Email</a>
      <a
        href="https://www.linkedin.com/in/rajo-mampionona-rakotoniaina-380882367/"
        target="_blank"
        rel="noopener noreferrer"
      >
        LinkedIn
      </a>
    </div> */}
  </header>
);

export default Header;
